import React, { useEffect, useMemo, useState } from "react";

import { ColumnFilter, SearchSuggest } from "Components/AppGrid/shipeezi-new-grid";
import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";
import { Searches } from "Models/shipeezi.table";
import { useTranslation } from "react-i18next";

export const DespatchTaskFilters = () => {
  const { despatchSearchColumns, setDespatchSearchColumns } = useOperationDespatchContext();
  const { t: translate } = useTranslation();

  const [searchInput, setSearchInput] = useState<string>("");
  const [searchOptions, setSearchOptions] = useState<ColumnFilter[]>([]);

  const searchColumns = useMemo(() => {
    return [
      { name: "leader", title: translate("leaderName") },
      { name: "members", title: translate("memberName") },
      { name: "orderReference", title: translate("orderReference") },
      { name: "equipment", title: translate("equipmentName") },
      { name: "storageBoxes", title: translate("storageBoxNumber") },
    ];
  }, []);

  useEffect(() => {
    setSearchOptions(despatchSearchColumns);
  }, [despatchSearchColumns]);

  const onSelectSearch = (options: ColumnFilter[]) => {
    const newSearches: Searches = [];

    options.forEach((option) => {
      if (option.value) newSearches.push({ [option.name]: option.value! });
    });
    setSearchOptions(options);
    setDespatchSearchColumns(options);
  };

  return (
    <SearchSuggest
      columns={searchColumns}
      columnsSelected={searchOptions}
      onChangeColumnsSelected={onSelectSearch}
      inputValue={searchInput}
      onChangeInput={setSearchInput}
      placeholder={`${translate("search")}...`}
    />
  );
};
